<template>
  <b-col class="col-12 position-relative">
    <b-link v-if="id" class="text-body" :title="$t('apiaries.delete')" @click.prevent="clickDelete">
      <span class="icon-delete_filled" aria-hidden="true"></span>
    </b-link>
    <b-modal :id="'confirmApiary_'+ id" centered hide-header-close @ok="doDelete">
      <template slot="modal-title">
      {{ $t('apiaries.confirm_delete.title') }}
      </template>
        {{ $t('apiaries.confirm_delete.text') }}
      <template slot="modal-footer" slot-scope="{ ok, cancel }">
        <b-button size="lg" class="ml-auto" @click="cancel()">
          {{ $t('apiaries.confirm_delete.no') }}
        </b-button>
        <b-button size="lg" class="mr-auto" @click="ok()">
          {{ $t('apiaries.confirm_delete.yes') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal :id="'offLineModal_'+ id" centered hide-header-close @ok="hideModal">
      <template slot="modal-title">
        {{ $t('offLineModal.title') }}
      </template>
      {{ $t('offLineModal.text') }}
      <template slot="modal-footer" class="offline-modal-footer" slot-scope="{ ok }">
        <b-button size="lg" class="mt-3" @click="ok()">
          {{ $t('offLineModal.ok') }}
        </b-button>
      </template>
    </b-modal>
  </b-col>
</template>

<script>
export default {
  name: 'ApiaryDelete',
  props: ['id'],
  methods: {
    clickDelete () {
      if (navigator.onLine) {
        this.showModal()
      } else {
        this.showOffLineModal()
      }
    },
    showModal () {
      this.$bvModal.show('confirmApiary_' + this.id)
    },
    showOffLineModal () {
      this.$bvModal.show('offLineModal_' + this.id)
    },
    hideModal () {
      this.$bvModal.hide('offLineModal_' + this.id)
    },
    async doDelete () {
      let result
      try {
        this.$emit('confirmDelete', this.id)
        const token = await this.$api.user.getToken()
        result = await this.$api.apiaries.deleteItem({ id: this.id, token })
      } catch (e) { // network error etc.
        if (e.response && e.response.status === 403) {
          this.$router.replace('/login')
        }
        return false
      }
      this.$router.replace('/apiaries')
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../scss/config';

  h2 {
    font-size: 1.5rem;
    font-family: $font-family-sans-serif;
  }
  .action-row {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 1.5rem;
    line-height: 1rem;

    > * {
      display: inline-block;
      padding: 1rem 1.25rem;

      &:hover {
        text-decoration: none;
      }
    }
  }

  .card {
    background-color: $secondary-light;
  }
  .card-body {
    padding: 1.25rem;
  }
</style>
